export type Span = { min: number; max: number };

export const clamp = (v: number, lo: number, hi: number) =>
  Math.max(lo, Math.min(hi, v));

/** Shift the window by deltaMs, keeping width, clamped within the data span. */
export function pan(view: Span, deltaMs: number, data: Span): Span {
  const width = view.max - view.min;
  let min = view.min + deltaMs;
  if (min < data.min) min = data.min;
  if (min + width > data.max) min = data.max - width;
  return { min, max: min + width };
}

export function resizeLeft(
  view: Span,
  deltaMs: number,
  data: Span,
  minSpan: number,
): Span {
  return {
    min: clamp(view.min + deltaMs, data.min, view.max - minSpan),
    max: view.max,
  };
}

export function resizeRight(
  view: Span,
  deltaMs: number,
  data: Span,
  minSpan: number,
): Span {
  return {
    min: view.min,
    max: clamp(view.max + deltaMs, view.min + minSpan, data.max),
  };
}

/** Center the window on centerMs, keeping width, clamped within the data span. */
export function recenter(view: Span, centerMs: number, data: Span): Span {
  const width = view.max - view.min;
  let min = centerMs - width / 2;
  if (min < data.min) min = data.min;
  if (min + width > data.max) min = data.max - width;
  return { min, max: min + width };
}
